// src/dayjsConfig.js
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import relativeTime from "dayjs/plugin/relativeTime"
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
// Import locales for multi-language support
import "dayjs/locale/es"; // Spanish
import "dayjs/locale/en"; // English

// All required plugins are extended here
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime);
dayjs.extend(isSameOrBefore);

export default dayjs;